<template>
  <div>
    <div class="search-select">
      <div class="search">
        <!-- 下拉切换审批、抄送 -->
        <van-dropdown-menu class="drop-down" v-if="!isShowSearchBar">
          <van-dropdown-item
            v-model="dropdownValue"
            :options="dropdownList"
            @change="dropDownChange"
          />
        </van-dropdown-menu>
        <div class="btns">
          <!-- 搜索框 Tips: 在 van-search 外层增加 form 标签，且 action 不为空，即可在 iOS 输入法中显示搜索按钮-->
          <form action="/">
            <van-search
              v-if="isShowSearchBar"
              class="search-bar"
              v-model="searchName"
              placeholder="请输入姓名"
              shape="round"
              show-action
              @cancel="isShowSearchBar = false"
              @search="searchFun"
              @clear="searchFun"
            ></van-search>
          </form>
          <!-- 搜索和筛选按钮 -->
          <div
            class="search-btn flex-center"
            v-if="!isShowSearchBar"
            @click="isShowSearchBar = true"
          >
            <i class="iconfont">&#xe60b;</i>&nbsp;搜索
          </div>
          <div class="select-btn flex-center" @click="showSelectCon = !showSelectCon">
            <i class="iconfont">&#xe61d;</i>&nbsp;筛选
          </div>
        </div>
      </div>
      <!-- 筛选组件：时间范围、审批状态 -->
      <office-select-choose v-show="showSelectCon" :setCondition="setCondition"
                            :txt="searchName"></office-select-choose>
    </div>
    <van-list :style="styleSearch"
              class="refreshWrap"
              v-model="isRefresh"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
    >
      <ul class="leave-list">
        <li class="leave-item clearfix" v-for="item in list" :key="item.LeaveApplicationID">
          <div @click="details(item)">
            <div class="left fl">
                <span v-if="item.Icon===''">{{item.FullName ? showName(item.FullName) : ''}}</span>
                <div class="details-state fl" v-else :style="{background:'url('+ item.Icon+')' + '0/cover'}"></div>
            </div>
            <div class="right">
              <div class="title">
                <div class="nowrap tit">{{item.FullName}}提交的请假申请</div>
                <div class="date fr">{{xy.moment(item.CreateByDate).format('YYYY-MM-DD')}}</div>
              </div>
              <div class="type">请假类型：{{item.TeacherLeaveTypeName}}</div>
              <div class="info">
                <img :src="cardImgUrl" alt/>
                <div class="right-con">
                  <p>
                    <span
                      class="date"
                    >{{xy.moment(item.StartTime).format('YYYY-MM-DD')}}&nbsp;&nbsp;{{!item.IsCycleLeave?xy.moment(item.StartTime).format('HH:mm'):''}}</span>
                  </p>
                  <p>
                    <span
                      class="date"
                    >{{xy.moment(item.EndTime).format('YYYY-MM-DD')}}&nbsp;&nbsp;{{!item.IsCycleLeave?xy.moment(item.EndTime).format('HH:mm'):''}}</span>
                  </p>
                </div>
              </div>
              <!-- 0待审批，1审批中，2已通过，3已拒绝，4已撤销，5已过期 （40已撤回） -->
              <div
                class="status"
                v-if="item.ApplicationStateNew !== -1"
                :style="{color: (item.ApplicationStateNew === 0 ? '#4196FF' : item.ApplicationStateNew === 1 ? '#E8A022' : item.ApplicationStateNew === 2 ? '#21A83E' : item.ApplicationStateNew === 3 ? '#D83737' : item.ApplicationStateNew === 4 ? '#666666' : item.ApplicationStateNew === 5 ? '#666666' : '')}"
              >{{item.ApplicationStateNameNew}}
              </div>
            </div>
          </div>
        </li>
      </ul>
    </van-list>
  </div>
</template>
<script>
  import OfficeSelectChoose from "../../components/OfficeSelectChoose";

  const cardImgUrl = require("@/assets/attendance/data_ask.png");
  export default {
    name: "Approval",
    components: {
      OfficeSelectChoose
    },
    data() {
      return {
        imgUrl: this.xyMApi + '/base',
        cardImgUrl: cardImgUrl,
        //是否为审批：审批or抄送
        isApproval: true,

        //list
        pageIndex: 1,
        pageSize: 15,
        totalItems: 0,
        isRefresh: false, // 是否加载中
        finished: false, // 加载是否完成
        list: [],

        approvalStatus: 99, //审批状态 默认-1
        searchName: "",
        leaveType: 0,
        startTime: "",
        endTime: "",

        //search
        isShowSearchBar: false, //搜索框展示
        showSelectCon: false, //筛选下拉框展示

        //下拉菜单
        dropdownValue: 0,
        dropdownList: [{text: "审批", value: 0}, {text: "抄送", value: 1}],
        styleSearch: {}
      };
    },
    created() {
      this.getList();
    },

    watch: {
      'showSelectCon': {
        deep: true,
        handler: function (newV, oldV) {
          console.log(newV, oldV)
          if (newV) {
            this.styleSearch = {'display': 'none'}
          } else {
            this.styleSearch = {}
          }
        }
      },
    },

    mounted() {
    },
    methods: {
      showName(name) {
        // 纯中文：汉字姓名大于2个字展示最后2个字，小于等于2个字
        if (/^[\u4e00-\u9fa5]+$/g.test(name)) {
          return name.length > 3 || name.length === 3 ? name.slice(-2) : name;
        } else if (/^[A-Za-z]+$/g.test(name)) {
          // 纯英文名只展示两个字母
          return name.slice(0, 2);
        } else {
          // 其他
          return name.slice(0, 2);
        }
      },
      //切换审批和抄送
      dropDownChange(value) {
        if (value === 0) {
          //审批：0
          this.isApproval = true;
          this.list = [];
          this.pageIndex = 1
          this.getList();
        } else if (value === 1) {
          //抄送：1
          this.isApproval = false;
          this.list = [];
          this.pageIndex = 1
          this.getList();
        }
      },
      //list
      async getList() {
        let url = "";
        if (this.isApproval) {
          url = `${this.$store.state.apiPath}/api/TeacherLeaveForMobile/GetApprovalPageList`;
        } else {
          url = `${this.$store.state.apiPath}/api/TeacherLeaveForMobile/GetCCPageList`;
        }
        let res = await this.xyapi.get(url, {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          searchText: this.searchName,
          leaveType: this.leaveType,
          state: this.approvalStatus,
          startTime: this.startTime,
          endTime: this.endTime
        });
        if (res.success) {
          // 加载状态结束
          this.isRefresh = false;
          if (res.data.data) {
            this.totalItems = res.data.totalRecords;
            let _list = res.data.data;
            this.list = this.list.concat(_list);
          } else {
            this.finished = true;
          }
          if (this.list.length >= this.totalItems) {
            this.finished = true;
          }
        }
        // 加载状态结束
        this.isRefresh = false;
      },
      onLoad(params = null) {
        this.pageIndex++;
        params = Object.assign({pageIndex: this.pageIndex}, params);
        this.getList(params);
      },
      //重置条件
      reset() {
        this.pageIndex = 1;
        this.list = [];
        this.getList();
      },

      //搜索触发
      searchFun() {
        this.pageIndex = 1;
        this.finished = false;
        this.list = [];
        this.getList();
      },
      //监听提交下拉筛选
      setCondition(leaveTypeID, applicationState, startTime, endTime, seaTxt) {
        this.showSelectCon = false;
        this.pageIndex = 1;
        this.finished = false;
        this.approvalStatus = applicationState;
        this.leaveType = leaveTypeID;
        this.startTime = startTime;
        this.endTime = endTime;
        this.searchName = seaTxt;
        this.list = [];
        this.getList();
      },
      // 详情
      details(item) {
        console.log(item);
        this.$router.push({
          name: "TeacherLeaveDetails",
          params: {
            ApprovalFlowID: item.ApprovalFlowID,
            TeacherLeaveApplicationID: item.TeacherLeaveApplicationID,
            isFrom: "approval",
            type: this.isApproval
          }
        });
      }
    }
  };
</script>
<style lang="less" scoped>
  .van-ellipsis {
    font-size: 28px;
    color: #505050;
  }

  .search {
    display: flex;
    background: #fff;
    height: 80px;
    padding: 0 15px;

    .drop-down {
      flex: 3;
      background: #f3f3f3;
      // margin: 10px 20px 10px 0;
      // border-radius: 6px;
    }

    .btns {
      flex: 2;
      display: flex;
      color: #505050;

      .search-btn {
        flex: 1;
      }

      .search-bar {
        flex: 4;
      }

      .select-btn {
        flex: 1;
      }
    }
  }

  .approval-con {
    padding: 15px;
  }

  // list
  .refreshWrap {
    .leave-list {
      padding: 15px;

      .leave-item {
        background: #fff;
        border-radius: 14px;
        box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
        margin-bottom: 16px;
        padding: 12px 31px 22px 19px;

        .left {
          width: 64px;

          span {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 64px;
            height: 64px;
            text-align: left;
            border-radius: 50%;
            background: @blue;
            font-size: 22px;
            color: #fff;
          }
          .details-state {
            width: 64px;
            height: 64px;
            background: #2980fe;
            border-radius: 50%;
            text-align: center;
            line-height: 92px;
            // margin-top: 40px;
            // margin-left: 70px;
            color: #fff;
            font-size: 30px;
            background-size: 92px 92px;
          }
        }

        .right {
          padding-left: 87px;

          .title {
            display: flex;
            justify-content: space-between;

            .tit {
              flex: 1;
              max-width: 60%;
              font-size: 30px;
              line-height: 64px;
              font-weight: bold;
              color: #333;
            }

            .date {
              line-height: 64px;
              color: #b4b4b4;
              font-size: 24px;
            }
          }

          .type {
            font-size: 24px;
            color: #999;
            width: fit-content;
            height: 36px;
            line-height: 36px;
            padding: 0 20px 0 11px;
            background: rgba(249, 249, 249, 1);
            border-radius: 14px 0px 14px 0px;
          }

          //请假周期时间
          .info {
            margin-top: 15px;
            display: flex;
            color: #666;

            img {
              width: 13px;
              height: 73px;
              margin-top: 10px;
              margin-right: 10px;
            }

            .right-con {
              font-size: 26px;

              .date {
                margin-right: 10px;
                font-size: 28px;
              }

              p:first-child {
                margin-top: 2px;
              }

              p:last-child {
                margin-top: 31px;
              }
            }
          }

          //状态
          .status {
            font-size: 28px;
            margin: 17px 0 0;
            color: #666;
          }
        }
      }
    }
  }
</style>
